import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_AI_TWIN_DEMO_3 = {
  title: `To gain valuable insights, I have been \nequipped with the powerful Gen AI-enabled \nAI-Twin for Marketer. With this innovative \ntool at my disposal, I can now <span style="color: #BEE3FF;">inquire \nabout the shifting buying patterns with \nprecision and clarity,</span> empowering me to \nmake informed decisions.`,
  subtitle: "NEAR Real-Time Insights",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("AITWIN_308"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("AITWIN_306"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "AI_TWIN/AI_Twin_04.png",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "AI_TWIN/InfosysTopazLogo.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "AI_TWIN/AI_TWIN_DEMO_3_computer.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
          effect: "animate-opacity",
        },
        {
          image: "AI_TWIN/AI_TWIN_DEMO_3_bubble_1.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
        },
        {
          image: "AI_TWIN/AI_TWIN_DEMO_3_bubble_2.png",
          imageStyle: { position: "absolute", right: "0px", bottom: "0px" },
        },
        {
          image: "AI_TWIN/AI_TWIN_DEMO_3_bubble_3.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
        },
      ]}
      pageNumber={"AITWIN_307"}
    />
  ),
};
